import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/login.vue";

const routerList = [];

function importAll(r) {
  r.keys().forEach((key) => routerList.push(...r(key).default));
}
//载入所有路由文件
importAll(
  require.context(
    "../../packages/sso/routers",
    true,
    /routes\.js/
  )
);

Vue.use(VueRouter);

const routes = [
  {
    path: "/login/v2",
    name: "Login",
    component: Login,
  },
  ...routerList,
];
const router = new VueRouter({
  routes,
});

export default router;
